<template>
    <a @click="switchLanguage">
        <font-awesome-icon icon="globe-americas" />
        <span class="text font-semibold uppercase" v-if="$i18n.locale === secondaryLanguage">
            {{ primaryLanguage }}
        </span>
        <span class="text font-semibold uppercase" v-if="$i18n.locale === primaryLanguage">
            {{ secondaryLanguage }}
        </span>
    </a>
</template>

<script>
export default {
    name: "SwitchLanguage",
    methods: {
        switchLanguage() {
            if (this.$i18n.locale === this.secondaryLanguage) {
                this.$i18n.locale = this.primaryLanguage;
            } else {
                this.$i18n.locale = this.secondaryLanguage;
            }
            this.$inertia.post(route('user.setLanguage').url(), {language: this.$i18n.locale}, { preserveScroll: true });
        },

    },
    computed: {
        primaryLanguage() {
            return window.primaryLanguage;
        },
        secondaryLanguage() {
            return window.secondaryLanguage;
        }
    }
}
</script>

<style scoped>

</style>
